exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index-shape-pick-menu-container-1YZuS{-webkit-backdrop-filter:blur(16px);backdrop-filter:blur(16px)}.index-shapemw-FUlD1{width:318px;overflow-y:scroll;padding-bottom:12px;background-color:#fff}.index-thumbt-2Buzm{margin-top:16px;margin-left:13px;color:grey;font-size:12px;font-family:PingFangSC-Regular}.index-thumbiw-ubBDP{margin-left:12px;display:flex;flex-wrap:wrap;flex-direction:row}.index-sub-3Tf46{width:22px;height:22px;padding:1px;margin-right:8px;margin-top:8px;text-align:center;overflow:hidden}.index-sub-3Tf46:hover{cursor:pointer;background-color:rgba(0,0,0,.04)}.index-sub-3Tf46:active{cursor:pointer;background-color:rgba(0,0,0,.08)}", ""]);

// Exports
exports.locals = {
	"shape-pick-menu-container": "index-shape-pick-menu-container-1YZuS",
	"shapemw": "index-shapemw-FUlD1",
	"thumbt": "index-thumbt-2Buzm",
	"thumbiw": "index-thumbiw-ubBDP",
	"sub": "index-sub-3Tf46"
};